import React from 'react';
import { ButtonProps } from 'antd/lib/button';

import { CmonJobInstanceCommand } from '../../../services/cmon/models/CmonJobInstance';
import CcNode from '../../../services/models/CcNode';
import NodeStepDownForm from './NodeStepDownForm';
import ButtonWithForm from '../../../common/General/ButtonWithForm';
import JobActionButton from '../../Jobs/JobActionButton';

export default NodeStepDownButton;

export type NodeStepDownButtonProps = ButtonProps & {
    node: CcNode;
    children?: React.ReactNode;
    onSuccess?: () => void;
};

function NodeStepDownButton({
    node,
    children,
    onSuccess,
    ...rest
}: NodeStepDownButtonProps) {
    return (
        <ButtonWithForm
            button={
                <JobActionButton
                    command={CmonJobInstanceCommand.REPLSET_STEP_DOWN}
                    clusterId={node.clusterid}
                    extraKey={[node.hostname, node.port]}
                    {...rest}
                >
                    {children || 'Step down node'}
                </JobActionButton>
            }
            form={<NodeStepDownForm node={node} onSuccess={onSuccess} />}
        />
    );
}
